<template>
    <div class="container-fluid" :class="{ 'login-wrapper': isLoginPage}">
        <notifications group="main" position="bottom right" :duration="7000"/>
        <div v-if="$route.path !== '/login'" style="position: relative">
            <app-header :username="username"
                        :showMenuFlag="showMenuFlag"
                        @toggleMenu="toggleMenu">
            </app-header>
            <div class="row app-wrapper">
                <side-menu v-if="this.$route.path !== '/login' && showMenuFlag"></side-menu>
                <div class="main-content">
                    <div class="col-sm-12">
                      <transition name="fade" mode="out-in">
                        <router-view></router-view>
                      </transition>
                    </div>
                </div>
            </div>
        </div>
        <div class="container col-sm-6" v-else>
            <Login></Login>
        </div>
    </div>
</template>

<script>
  import { mapState } from 'vuex';
  import Vue from 'vue';
  import AppHeader from './components/common/Header.vue'
  import SideMenu from './components/common/SideMenu.vue'
  import Login from './components/pages/Login.vue';

  export default {
    components: {
      SideMenu,
      AppHeader,
      Login
    },
    data() {
      return {
        showMenuFlag: true
      }
    },
    methods: {
      toggleMenu(menuFlag) {
        this.showMenuFlag = menuFlag;
      }
    },
    computed: {
      ...mapState('login', ['username']),
      isLoginPage() {
        return this.$route.path === '/login'
      }
    }
  }

</script>

<style scoped>

    .app-wrapper {
        margin-left: 0;
    }

    .container-fluid {
        padding-top: 5px;
        padding-left: 5px;
        height: 100vh;
    }

    .login-wrapper {
        background-image: url('assets/images/backgrounds/login_bg.jpg');
    }

    .main-content {
        margin-left: 90px;
        width: calc(100% - 90px);
    }

    .fade-enter-active, .fade-leave-active {
      transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue